import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store';
import { postOptions } from '../../../enums/enums';
import DefaultPagination from '../../../components/material-ui/pagination/DefaultPagination';

export default function GamersPagination({ onFindClick }) {
  const pageCount = useAppSelector((state) => state.reports.gamers.payload.pageCount);
  const pageSize = useAppSelector((state) => state.reports.gamers.payload.pageSize);
  const pageNo = useAppSelector((state) => state.reports.gamers.payload.pageNo);

  const [curPage, setCurPage] = useState(pageNo || 1);
  const [selectRecord, setSelectRecord] = useState(pageSize || postOptions[0].value);

  useEffect(() => {
    if (!pageNo) return;
    setCurPage(pageNo);
  }, [pageNo]);

  return (
    <DefaultPagination
      curPage={curPage}
      pageCount={pageCount}
      selectRecord={selectRecord}
      setCurPage={setCurPage}
      setSelectRecord={setSelectRecord}
      onFindClick={onFindClick}
    />
  );
}
